// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"VQ-z","inlineTitle":"WQ-z","sponsoredAdsWrapper":"XQ-z","marketplaceRecosWrapper":"YQ-z"};